import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import { CourseInterestType, GetCourseInterestResponse } from '@inversor-hub/types';

export function useCreateCourseInterest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (type: CourseInterestType) => {
      await apiClient.post('/course-interest', { type });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-interest'] });
    },
  });
}

export function useGetCourseInterest(type: CourseInterestType) {
  return useQuery({
    queryKey: ['course-interest', type],
    queryFn: async () => {
      const response = await apiClient.get<GetCourseInterestResponse>(`/course-interest/${type}`);
      return response.data.data;
    },
  });
}
